export default __webpack_public_path__ + "static/media/no-coins-for-you-.258e5f5b.jpg";